import { getNavigationHistory } from '../utils/appNavigationHistory';
const packageJson = require('../../package.json');

const VALUE_MAX = 12000;
const MAX_LOCALSTORAGE_KEYS = 250;

function getIssueReportEndpointUrl() {
    const apiBase = process.env.REACT_APP_API_BASE_URL || '';
    if (apiBase) {
        const origin = apiBase.replace(/\/api\/?$/, '');
        return `${origin.replace(/\/+$/, '')}/public/issue-report`;
    }
    if (typeof window !== 'undefined' && window.location?.origin) {
        return `${window.location.origin}/public/issue-report`;
    }
    return '/public/issue-report';
}

function collectLocalStorageSnapshot() {
    const out = {};
    try {
        const keys = [];
        for (let i = 0; i < localStorage.length; i += 1) {
            const k = localStorage.key(i);
            if (k != null) keys.push(k);
        }
        const slice = keys.slice(0, MAX_LOCALSTORAGE_KEYS);
        slice.forEach((k) => {
            let v = localStorage.getItem(k);
            if (v != null && v.length > VALUE_MAX) {
                v = `${v.slice(0, VALUE_MAX)}\n…[truncated]`;
            }
            out[k] = v;
        });
        if (keys.length > MAX_LOCALSTORAGE_KEYS) {
            out.__truncated_key_count = keys.length - MAX_LOCALSTORAGE_KEYS;
        }
    } catch (e) {
        out.__error__ = String(e);
    }
    return out;
}

async function fetchVersionJson() {
    try {
        const base = process.env.PUBLIC_URL || '';
        const url = `${base.replace(/\/+$/, '')}/version.json`;
        const res = await fetch(`${url}?t=${Date.now()}`, { cache: 'no-store' });
        if (!res.ok) return null;
        return await res.json();
    } catch {
        return null;
    }
}

/**
 * Gathers client context for an issue report (version, route history, storage, environment).
 */
export async function buildIssueReportDiagnostics() {
    const versionJson = await fetchVersionJson();
    return {
        appVersionFromPackage: packageJson.version,
        versionJson,
        navigationHistory: getNavigationHistory(),
        localStorage: collectLocalStorageSnapshot(),
        userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
        language: typeof navigator !== 'undefined' ? navigator.language : '',
        languages: typeof navigator !== 'undefined' ? navigator.languages : undefined,
        platform: typeof navigator !== 'undefined' ? navigator.platform : '',
        timeZone: typeof Intl !== 'undefined' ? Intl.DateTimeFormat().resolvedOptions().timeZone : undefined,
        href: typeof window !== 'undefined' ? window.location.href : '',
        pathname: typeof window !== 'undefined' ? window.location.pathname : '',
        search: typeof window !== 'undefined' ? window.location.search : '',
        viewport:
            typeof window !== 'undefined'
                ? { innerWidth: window.innerWidth, innerHeight: window.innerHeight, devicePixelRatio: window.devicePixelRatio }
                : null,
        collectedAt: new Date().toISOString(),
    };
}

/**
 * POST issue report to backend (same recipient as marketing contact form).
 */
export async function submitIssueReport({ email, message }) {
    const diagnostics = await buildIssueReportDiagnostics();
    const url = getIssueReportEndpointUrl();
    const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            email: email.trim(),
            message: message.trim(),
            diagnostics,
        }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
        const err = new Error(data.message || res.statusText || 'Request failed');
        err.status = res.status;
        throw err;
    }
    return data;
}
